import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './businessscandals.json'; 

const Businessscandals = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Corporate ethics, fraud vocabulary, and business English. B2/C1 level reading, grammar, and discussion exercises."
            level="B2"
            title="Business Scandals"
            image="/Images/enron.webp"
            seoTitle="Free English Lesson Plans: Business Scandals"
            seoDescription="Corporate ethics, fraud vocabulary, and business English. B2/C1 level reading, grammar, and discussion exercises."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Businessscandals;


